export const MAX_REPEATS_X = Infinity;
export const MAX_REPEATS_Y = Infinity;
